import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getAgendaTypes,
  getDevicesTypes,
  getMeasuresGenericTypes,
  getMeasuresStatus,
  getMeasuresTypes,
  getMeasuresUnits,
  getPathologiesTypes,
  getPatientHealthInsuranceTypehealthCenter,
  getPatientPersonalDataTypesEducation,
  getPatientPersonalDataTypesEthnicity,
  getPatientPersonalDataTypesLanguage,
  getPatientPersonalDataTypesMaritalStatus,
  getPatientPersonalDataTypesWeightBaseline, getPeripherals,
  getPeripheralsMeasureTypes,
  getPeripheralsTypes,
  getRacesTypes,
  getRelationshipsTypes,
  getResolutions,
  getServiceReasonType,
  getServicesState,
  getServiceType,
  getSettingsDateFormat,
  getSettingsLanguages,
  getSettingsMeasurementUnits,
  getSexesTypes
} from "services/api";

export const getMeasuresTypesAsync: any | null = createAsyncThunk(
  'masters/getMeasuresTypes',
  async () => {
    const response = await getMeasuresTypes();
    return response?.data;
  },
);

export const getMeasuresUnitsAsync: any | null = createAsyncThunk(
  'masters/getMeasuresUnits',
  async () => {
    const response = await getMeasuresUnits();
    return response?.data;
  },
);

export const getMeasuresGenericTypesAsync: any | null = createAsyncThunk(
  'masters/getMeasuresGenericTypes',
  async () => {
    const response = await getMeasuresGenericTypes();
    return response?.data;
  },
);

export const getMeasuresStatusAsync: any | null = createAsyncThunk(
  'masters/getMeasuresStatus',
  async () => {
    const response = await getMeasuresStatus();
    return response?.data;
  },
);

export const getPeripheralsTypesAsync: any | null = createAsyncThunk(
  'masters/getPeripheralsTypes',
  async () => {
    const response = await getPeripheralsTypes();
    return response?.data;
  },
);

export const getPeripheralsAsync: any | null = createAsyncThunk(
  'masters/getPeripherals',
  async () => {
    const response = await getPeripherals();
    return response?.data;
  },
);

export const getPeripheralsMeasureTypesAsync: any | null = createAsyncThunk(
  'masters/getPeripheralsMeasureTypes',
  async () => {
    const response = await getPeripheralsMeasureTypes();
    return response?.data;
  },
);

export const getDevicesTypesAsync: any | null = createAsyncThunk(
  'masters/getDevicesTypes',
  async () => {
    const response = await getDevicesTypes();
    return response?.data;
  },
);

export const getRacesTypesAsync: any | null = createAsyncThunk(
  'masters/getRacesTypes',
  async () => {
    const response = await getRacesTypes();
    return response?.data;
  },
);

export const getSexesTypesAsync: any | null = createAsyncThunk(
  'masters/getSexesTypes',
  async () => {
    const response = await getSexesTypes();
    return response?.data;
  },
);

export const getAgendaTypesAsync: any | null = createAsyncThunk(
  'masters/getAgendaTypes',
  async () => {
    const response = await getAgendaTypes();
    return response?.data;
  },
);

export const getResolutionsAsync: any | null = createAsyncThunk(
  'masters/getResolutions',
  async () => {
    const response = await getResolutions();
    return response?.data;
  },
);

export const getPathologiesTypesAsync: any | null = createAsyncThunk(
  'masters/getPathologiesTypes',
  async () => {
    const response = await getPathologiesTypes();
    return response?.data;
  },
);

export const getPatientPersonalDataTypesMaritalStatusAsync: any | null = createAsyncThunk(
  'masters/getPatientPersonalDataTypesMaritalStatus',
  async (data: any) => {
    const response = await getPatientPersonalDataTypesMaritalStatus(data.path);
    return response?.data;
  },
);

export const getPatientPersonalDataTypesLanguageAsync: any | null = createAsyncThunk(
  'masters/getPatientPersonalDataTypesLanguage',
  async (data: any) => {
    const response = await getPatientPersonalDataTypesLanguage(data.path);
    return response?.data;
  },
);

export const getPatientPersonalDataTypesEducationAsync: any | null = createAsyncThunk(
  'masters/getPatientPersonalDataTypesEducation',
  async (data: any) => {
    const response = await getPatientPersonalDataTypesEducation(data.path);
    return response?.data;
  },
);

export const getPatientPersonalDataTypesEthnicityAsync: any | null = createAsyncThunk(
  'masters/getPatientPersonalDataTypesEthnicity',
  async (data: any) => {
    const response = await getPatientPersonalDataTypesEthnicity(data.path);
    return response?.data;
  },
);

export const getPatientPersonalDataTypesWeightBaselineAsync: any | null = createAsyncThunk(
  'masters/getPatientPersonalDataTypesWeightBaseline',
  async (data: any) => {
    const response = await getPatientPersonalDataTypesWeightBaseline(data.path);
    return response;
  },
);

export const getPatientHealthInsuranceTypehealthCenterAsync: any | null = createAsyncThunk(
  'masters/getPatientHealthInsuranceTypehealthCenter',
  async () => {
    const response = await getPatientHealthInsuranceTypehealthCenter();
    return response?.data;
  },
);

export const getRelationshipsTypesAsync: any | null = createAsyncThunk(
  'masters/getRelationshipsTypes',
  async () => {
    const response = await getRelationshipsTypes();
    return response?.data;
  },
);

export const getServiceTypeAsync: any | null = createAsyncThunk(
  'masters/getServiceType',
  async () => {
    const response = await getServiceType();
    return response?.data;
  },
);

export const getServiceReasonTypeAsync: any | null = createAsyncThunk(
  'masters/getServiceReasonType',
  async () => {
    const response = await getServiceReasonType();
    return response?.data;
  },
);

export const getSettingsLanguagesAsync: any | null = createAsyncThunk(
  'masters/getSettingsLanguages',
  async () => {
    const response = await getSettingsLanguages();
    return response?.data;
  },
);

export const getSettingsMeasurementUnitsAsync: any | null = createAsyncThunk(
  'masters/getSettingsMeasurementUnits',
  async () => {
    const response = await getSettingsMeasurementUnits();
    return response?.data;
  },
);

export const getSettingsDateFormatAsync: any | null = createAsyncThunk(
  'masters/getSettingsDateFormat',
  async () => {
    const response = await getSettingsDateFormat();
    return response?.data;
  },
);

export const getServiceStatesAsync: any | null = createAsyncThunk(
  'masters/getServiceStates',
  async () => {
    const response = await getServicesState();
    return response?.data;
  },
);
